import React, { useState } from "react"
import { motion } from 'framer-motion'
import logo from '../Assets/Images/rklogo.png'
import { sideRoutes } from '../Common/Routes'
import { useHistory } from "react-router-dom"
import { FaPowerOff } from "react-icons/fa6"
import { useDispatch } from "react-redux"
import { setLoggedIn, setUserDetails } from "../Store/Auth/actions"

const SideBar = () => {

    const [hoverIndex, setHoverIndex] = useState()
    const [homeRoutes, setHomeRoutes] = useState(sideRoutes)
    const history = useHistory()
    const dispatch = useDispatch()



    const viewMainMenu = (title, ind) => {
        // setHomeRoutes(homeRoutes.map((c, i) => {
        //     if (i === ind) {
        //         c.expand = !c.expand
        //     } else {
        //         c.expand = false
        //     }
        //     return c
        // }))
        history.push(title.link)
        // setClickedIndex(ind)
    }

    const logout = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('accountType')
        window.location.reload()
        dispatch(setUserDetails({}))
        dispatch(setLoggedIn(false))
        history.push('/')
    }


    return (
        <motion.div className={`px-5 w-58 py-10 fixed rounded-3xl bg-white h-[100vh] flex flex-col`}>
            <motion.div className="flex flex-row justify-start">
                <img src={logo} height={100} width={100} alt="logo" />
            </motion.div>
            <motion.div className={`flex flex-col h-full my-10 overflow-auto`}>
                {
                    homeRoutes.map((route, index) => {
                        return <motion.div className={`flex flex-col py-2`}>
                            <motion.div className={`flex flex-row px-2 hover:text-nameColor ${route.expand ? 'bg-nameColor/20 text-nameColor' : ''} text-lg font-bold py-2 cursor-pointer rounded-xl hover:bg-nameColor/20 transition duration-300 `} onClick={() => viewMainMenu(route, index)} onMouseEnter={() => setHoverIndex(index)} onMouseLeave={() => setHoverIndex(null)} >
                                <route.TitleIcon className={`my-1 mx-2  transition duration-300  ${index === hoverIndex ? 'hover:text-nameColor' : 'text-[grey]'}`} /> <motion.div className={`mx-2`}>{route.title}</motion.div>
                            </motion.div>
                        </motion.div>
                    })
                }
                <motion.div className={`flex flex-col py-2`}>
                    <motion.div className={`flex flex-row px-2 hover:text-nameColor  text-lg font-bold py-2 cursor-pointer rounded-xl hover:bg-nameColor/20 transition duration-300 `} onClick={() => logout()}>
                        <FaPowerOff className={`my-1 mx-2  transition duration-300 hover:text-nameColor text-[grey]`} /> <motion.div className={`mx-2`}>Logout</motion.div>
                    </motion.div>
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default SideBar